// extracted by mini-css-extract-plugin
module.exports = {"login":"login___+DlWZ","tabs":"tabs___1-ud0","prefixIcon":"prefixIcon___dHMtL","getCaptcha":"getCaptcha___xL4dE","submit":"submit___IiHmJ"};